






















































import { Component, Vue } from 'vue-property-decorator';
import DashboardHeader from '@/components/dashboard/DashboardHeader.vue';
import DashboardForm from '@/components/dashboard/DashboardForm.vue';
import DashboardGraph from '@/components/dashboard/DashboardGraph.vue';
import DashboardSpecBox from '@/components/dashboard/DashboardSpecBox.vue';
import { Specificity } from '@/interfaces/specificity.interface';
import { specificityModelFactory } from '@/models/specificity.model';
import { getRules } from '@/utilities/getRules.utility';
import { getSelectors } from '@/utilities/getSelectors.utility';
import { getSpecificity } from '@/utilities/getSpecificity.utility';
import { graphConfig } from '@/utilities/graph.utility';
import LineChart from '@/components/LineChart.vue';
import * as _ from 'lodash';

@Component({
  components: {
    DashboardHeader,
    DashboardForm,
    DashboardGraph,
    DashboardSpecBox,
    LineChart
  }
})
export default class Dashboard extends Vue {
  public sgtConfig: Specificity = specificityModelFactory();

  public onCssParsed($event) {

    // Ritorno le rules [contiene sia le direttive che gli important]
    this.sgtConfig.rules = {...getRules($event)};
    
    // Ritorno i selettori
    this.sgtConfig.selectors = {...getSelectors($event)};

    // Specificity Calculator is built for CSS Selectors Level 3.
    this.sgtConfig.specificityArr = getSpecificity(this.sgtConfig.selectors.selectorsArr);
    
    // Chart config
    this.sgtConfig.chart = {...graphConfig(this.sgtConfig)}

  }

}
